export default __webpack_public_path__ + "static/media/arrow-up.89802de3.svg";